module.exports = __webpack_public_path__ + "static/media/Gragi_French.f31e8a60.mp3";